<div class="w-full h-full flex flex-col gap-2">

  <wj-flex-grid #grid
                class="flex-1"
                [allowSorting]="options?.allowSorting"
                [allowPinning]="options?.allowSorting"
                [autoGenerateColumns]="false"
                [isReadOnly]="options?.isReadOnly"
                [itemsSource]="items">

    @for (column of columns; track column.binding) {
      @if (column.type === 'boolean') {
        <wj-flex-grid-column
          [header]="column.header"
          [binding]="column.binding">
        </wj-flex-grid-column>
      } @else {
        <wj-flex-grid-column
          [header]="column.header"
          [binding]="column.binding">
        </wj-flex-grid-column>
      }

    }


    <wj-flex-grid-filter (initialized)="initFilter(filter)" (filterChanged)="initFilter(filter)"  #filter/>
    <!-- Colunas são geradas dinamicamente no TS -->
  </wj-flex-grid>

  <!--  @for (column of this.columnsMultiselect; track column.key; ) {-->
  <!--      <wj-multi-select-->
  <!--        [itemsSource]="column.value"-->
  <!--        [id]="'multiSelect'+column.key" [showSelectAllCheckbox]="true"></wj-multi-select>-->
  <!--  }-->
</div>
